export default "__VITE_ASSET__BFuQ2LOG__"